import React, { memo } from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

const UiCheckbox = memo((props) => {
     const { label, id, handleChange, checked, name, disabled } = props;
     return (
          <FormGroup>
               <FormControlLabel
                    sx={{
                         "& .MuiFormControlLabel-label": { fontSize: "14px" },
                    }}
                    label={label}
                    onClick={handleChange}
                    control={
                         <Checkbox
                              disabled={disabled}
                              id={id}
                              name={name}
                              checked={checked}
                              onClick={handleChange}
                         />
                    }
               />
          </FormGroup>
     );
});

export default UiCheckbox;
